import React from 'react'
import _ from 'lodash'

const BkFlowError = props => {
  const {
    configData,
    availabilityData,
    parentClasses,
    errorTitle,
    errorMessage,
    responseError,
  } = props

  let urlData = null,
        hotelLabels = null

  if (
    availabilityData &&
    availabilityData.urlData
  ) {
    urlData = availabilityData.urlData
  }

  if (
    configData &&
    configData.hotel &&
    configData.hasOwnProperty.labels &&
    configData.hotel.labels[0]
  ) {
    hotelLabels = configData.hotel.labels[0]
  }

  let activeHotelCode = null,
      activeHotelPhoneNumber = null

  // Get hotel code from avail response
  if (!_.isEmpty(urlData) && urlData.hotelCode) {
    activeHotelCode = urlData.hotelCode
  }

  if (!_.isEmpty(configData)) {
    let matchedProperty = null

    if (
      configData.hotel &&
      configData.hotel.options &&
      configData.hotel.options.properties
    ) {
      // Match activeHotelCode to config properties array
       matchedProperty = configData.hotel.options.properties.find(function(property) {
        return property.hotelCode === String(activeHotelCode)
      })
    }

    // Set phone # by config or crs fallback
    if (
      !_.isEmpty(matchedProperty) &&
      matchedProperty.contactNumbers &&
      matchedProperty.contactNumbers.reservations
    ) {
      activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
    } else if (
      !_.isEmpty(availabilityData.hotelReservations) &&
      availabilityData.hotelReservations[0] &&
      availabilityData.hotelReservations[0].roomStays &&
      _.get(availabilityData.hotelReservations[0].roomStays, '[0].basicPropertyInfo.contactNumbers[0].phoneNumber')
    ) {
      activeHotelPhoneNumber = availabilityData.hotelReservations[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
    }
  }

  const title = errorTitle
    || _.get(hotelLabels, 'genericErrorTitle')
    || 'Oops!'
  const message = errorMessage
    || _.get(hotelLabels, 'genericErrorMessage')
    || 'There was an issue retrieving the hotel configuration - please wait a moment, and try again.'

  return (
    <div className={ parentClasses ? parentClasses : 'bk-flow-room__errors' }>
      <h4>{ title }</h4>

      <p className="u-remove-margin">{ message }</p>

      { activeHotelPhoneNumber &&
        <p>{ hotelLabels && hotelLabels.propertyContactMessage ? hotelLabels.propertyContactMessage : 'For immediate bookings or reservation questions please contact us at' }: <a href={ 'tel:' + activeHotelPhoneNumber }>{ activeHotelPhoneNumber }</a></p>
      }

      { responseError &&
        <p className="u-font-small u-font-bold u-remove-margin u-element-hidden">Error Message: { responseError }</p>
      }
    </div>
  )
}

export default BkFlowError



// WEBPACK FOOTER //
// ./src/components/elements/BkFlowError.js